/**
 * 气泡管理 Composable
 * 管理气泡的初始化、更新、过滤等功能
 */

const globalBubbleImageCache = {};

export default function useBubbles() {
  return {
    data() {
      return {
        bubbleTimer: null
      };
    },

    methods: {
      /**
       * 初始化气泡数据
       */
      initBubbleData(data) {
        if (!data || !Array.isArray(data)) return;
        
        data.forEach(item => {
          // 使用Vue.set确保响应式
          if (!item.bubbles) {
            this.$set(item, 'bubbles', []);
          }
          // 初始化上次生成时间，设为0确保首次调用能正常生成气泡
          if (!item.lastBubbleTime) {
            this.$set(item, 'lastBubbleTime', 0);
          }
        });
      },

      /**
       * 更新气泡（委托给子组件）
       */
      updateBubbles() {
        const view = this.$refs.sleepView;
        if (view && view.updateBubbles) {
          view.updateBubbles();
        }
      },

      /**
       * 预加载图片
       */
      preloadImage(src) {
        if (!src) return;
        const url = typeof src === 'string' ? src : (src && src.default) ? src.default : src;
        if (!url) return;
        if (globalBubbleImageCache[url]) return;
        const img = new Image();
        img.src = url;
        globalBubbleImageCache[url] = true;
      },

      /**
       * 预加载气泡背景图片
       */
      preloadBubbleImage() {
        try {
          const bubbleBgUrl = require('@/assets/bubble_bg.png');
          // 使用preloadImage方法，避免重复加载
          this.preloadImage(bubbleBgUrl);
        } catch (error) {
          // 如果图片不存在，忽略错误
          logger.warn('气泡背景图片预加载失败:', error);
        }
      },

      /**
       * 判断气泡是否过期
       */
      isBubbleExpired(bubble) {
        if (!bubble || !bubble.id) return true;
        // 从气泡id中提取时间戳（格式：timestamp-random-roomName-patientName）
        const parts = bubble.id.split('-');
        if (parts.length < 1) return true;
        const bubbleTimestamp = parseInt(parts[0], 10);
        if (isNaN(bubbleTimestamp)) return true;
        // 气泡5秒后过期
        const now = Date.now();
        return (now - bubbleTimestamp) > 5000;
      },

      /**
       * 过滤有效气泡（未过期且可见）
       */
      filterValidBubbles(bubbles) {
        if (!Array.isArray(bubbles)) return [];
        return bubbles.filter(bubble => {
          // 保留可见且未过期的气泡
          return bubble.visible !== false && !this.isBubbleExpired(bubble);
        });
      },

      /**
       * 合并现有气泡数据到新数据中
       */
      mergeExistingBubbleData(existingData, newData) {
        if (!existingData || !newData || !Array.isArray(existingData) || !Array.isArray(newData)) return;
        
        // 遍历新数据
        newData.forEach(newItem => {
          // 关键修复：使用 roomId 进行匹配，因为 roomId 是唯一标识且更可靠
          // roomId 不会在数据刷新时变化，而 roomName 和 patientName 可能会变化
          
          if (!newItem || !newItem.roomId) {
            return; // 跳过无效数据
          }
          
          // 在现有数据中查找匹配的项（使用 roomId 匹配）
          const existingItem = existingData.find(item => 
            item && item.roomId && 
            item.roomId.toString() === newItem.roomId.toString()
          );
          
          if (existingItem) {
            // 如果找到匹配项，合并气泡数据
            if (existingItem.bubbles && Array.isArray(existingItem.bubbles)) {
              // 过滤有效气泡（未过期且可见）
              const validBubbles = this.filterValidBubbles(existingItem.bubbles);
              
              // 将有效气泡合并到新数据中
              if (validBubbles.length > 0) {
                // 使用Vue.set确保响应式
                if (!newItem.bubbles) {
                  this.$set(newItem, 'bubbles', []);
                }
                // 合并有效气泡（避免重复）
                validBubbles.forEach(bubble => {
                  const exists = newItem.bubbles.some(b => b.id === bubble.id);
                  if (!exists) {
                    newItem.bubbles.push(bubble);
                  }
                });
              }
            }
            
            // 合并 lastBubbleTime（如果存在）
            if (existingItem.lastBubbleTime) {
              newItem.lastBubbleTime = existingItem.lastBubbleTime;
            }
          }
        });
      }
    }
  };
}

